// bully ignore[feature-imports-allowlist: bully.toml allowlists "src/sutra" but the check compares against the raw resolved specifier "sutra/tokens/colors" with no "src/" prefix (tools/bully/engine/src/language_engine/adapters/typescript/project/imports.rs:70) — every sutra/* import in the codebase already trips this. follow-up: .agents/follow-ups/bully-typescript-false-positive-rules.md, no-cross-feature-private-imports: same starts_with mismatch as above. follow-up: .agents/follow-ups/bully-typescript-false-positive-rules.md]
import { accents, brand } from 'sutra/tokens/colors'

// ── The categorical chart palette. Reorder/swap these to re-theme the charts. ──
// The 9 Sutra primitive hues, in series order (index 0 is the single-series default).
const HUE_ORDER = [
  accents.reflectionBlue, // blue  — single-series default
  brand.sunriseCoral, // red/orange
  accents.emeraldAura, // green — comparison series
  accents.goldenLight, // amber
  accents.violetHorizon, // purple
  accents.ceruleanFlow, // teal
  accents.crimsonBloom, // magenta
  accents.verdantGreen, // lime
  brand.stillNight, // slate/navy
] as const

// Weight tiers, strongest first. Do not go below 400 or above 500.
const WEIGHT_ORDER = [500, 400] as const

// 189 OKLCH color strings: all nine 500s, then all nine 400s.
export const SERIES_PALETTE: string[] = WEIGHT_ORDER.flatMap((weight) =>
  HUE_ORDER.map((ramp) => ramp[weight]),
)

// Named roles used by strategies that render a single or comparison series.
export const DEFAULT_SERIES_COLOR = SERIES_PALETTE[0]! // reflectionBlue 500
export const COMPARISON_SERIES_COLOR = accents.emeraldAura[500]
